import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import SplitImageListImagesScreen from "./SplitImageListImagesScreen";

function SplitImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Split Image & Image Splitter" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/split_image", title: "Split Image Online Free" },
    data2: { link: "/split_image", title: "Photo Splitter" },
    data3: {
      link: "/split_image",
      title: "Seperate Image Into Parts, Grid Maker",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Split images online easily. Divide photos into multiple parts or grids quickly with our fast, secure, and easy to use image splitter tool."
      ></meta>
      <meta
        name="keywords"
        content="split image, image splitter, split images online, divide image, cut image online, split photo, image cut tool, photo splitter, split image into parts, image slicing tool, online image splitter, split image grid, split pictures online, image editor online, split image free, grid maker, image grid maker, tilable image split, seperate image into multiple parts,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <SplitImageListImagesScreen title={title}></SplitImageListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Split Image website offers a fast, reliable, and privacy focused solution for dividing images into multiple parts without requiring an internet connection. Designed to work fully offline, this powerful image splitter processes images directly on your device, ensuring complete data security and zero uploads. Whether you need to split a large image into equal sections, divide photos for social media grids, print posters across multiple pages, or separate scanned images, this tool delivers precise results with high quality. Users can also choose optional online access, making it flexible enough to function as a split image online and split photo online tool while still providing the benefits of offline processing. Supporting popular formats such as JPG, PNG, and WebP, the platform works as a dependable photo splitter for personal and professional use. With an intuitive interface and customizable split options like rows, columns, or custom dimensions, users can split images quickly and efficiently. Ideal for designers, students, marketers, and content creators, this image splitter helps save time and improves workflow productivity. If you are looking for a secure split image tool, an easy to use image splitter, or a flexible split image online solution with offline support, this website provides an efficient way to split images effortlessly." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Split",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Split Image Tool"
            why_use={[
              {
                title: "Split Large Images into Smaller Parts",
                description:
                  "Our split image tool allows users to divide large images into smaller sections easily. Using this image splitter or split image online helps manage oversized images efficiently.",
              },
              {
                title: "Ideal for Social Media Grid Layouts",
                description:
                  "This photo splitter is perfect for creating Instagram grids and social media layouts. With a split photo online tool, users can divide one image into multiple posts.",
              },
              {
                title: "Easy Poster and Banner Printing",
                description:
                  "Split image tools allow large posters and banners to be divided into printable sections, making image splitter tools useful for high-quality printing.",
              },
              {
                title: "Offline Processing for Privacy",
                description:
                  "This offline split image solution processes images directly on your device, ensuring privacy without uploading files to a split image online service.",
              },
              {
                title: "Save Time and Reduce Manual Effort",
                description:
                  "Our photo splitter automates image division, eliminating manual cropping and saving time for designers, students, and professionals.",
              },
              {
                title: "Preserve Image Quality",
                description:
                  "Advanced image splitter tools maintain original resolution and clarity while splitting images for professional-quality output.",
              },
              {
                title: "Flexible Image Splitting Options",
                description:
                  "Modern split image tools offer row, column, and custom size options, giving users full control over how images are divided.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Split image online and offline tools support JPG, PNG, WebP, and other popular formats for flexible image processing.",
              },
              {
                title: "Useful for Design and Education",
                description:
                  "Designers, marketers, and educators use photo splitter tools for presentations, assignments, and visual content creation.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default SplitImagesMain;
